"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Toolbar = exports.Row = exports.ProgressBar = exports.Pagination = exports.Column = exports.Cell = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require("immutable");

var I = _interopRequireWildcard(_immutable);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _filters = require("../filters");

var _filters2 = _interopRequireDefault(_filters);

var _LoadingIcon = require("../LoadingIcon");

var _LoadingIcon2 = _interopRequireDefault(_LoadingIcon);

var _SectionHeader = require("../SectionHeader");

var _SectionHeader2 = _interopRequireDefault(_SectionHeader);

var _ServerError = require("../ServerError");

var _ServerError2 = _interopRequireDefault(_ServerError);

var _Cell = require("./Cell");

var _Cell2 = _interopRequireDefault(_Cell);

var _Column = require("./Column");

var _Column2 = _interopRequireDefault(_Column);

var _Pagination = require("./Pagination");

var _Pagination2 = _interopRequireDefault(_Pagination);

var _ProgressBar = require("./ProgressBar");

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Row = require("./Row");

var _Row2 = _interopRequireDefault(_Row);

var _Toolbar = require("./Toolbar");

var _Toolbar2 = _interopRequireDefault(_Toolbar);

require("./Table.scss");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.Cell = _Cell2.default;
exports.Column = _Column2.default;
exports.Pagination = _Pagination2.default;
exports.ProgressBar = _ProgressBar2.default;
exports.Row = _Row2.default;
exports.Toolbar = _Toolbar2.default;


var handlersValidator = function handlersValidator(props) {
  if (!props.dataHandler && !props.itemHandler) {
    return new Error("You should pass `dataHandler` or `itemHandler` props for table to proccess the data." + " Validation failed.");
  }
};

var Table = (_temp2 = _class = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      data: I.Map(),
      dataError: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this._isMounted = true;
      this.loadData();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps, nextContext) {
      var _this2 = this;

      var query = I.fromJS(this.context.location.query);
      var nextQuery = I.fromJS(nextContext.location.query);
      if (I.is(query, nextQuery)) {
        return;
      }

      this.setState(function (_ref2) {
        var data = _ref2.data;
        return {
          data: data.set("loading", true)
        };
      }, function () {
        return _this2.loadData(nextContext);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "getAPIParams",
    value: function getAPIParams() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
      var perPage = this.props.perPage;

      var params = _extends({
        ordering: this.getCurrentOrdering(context),
        page: this.getCurrentPage(context)
      }, this.getCurrentFilters(context), {
        "per_page": perPage,
        "_": Date.now()
      });

      // remove undefined && null keys
      Object.keys(params).forEach(function (key) {
        return (params[key] === undefined || params[key] === null) && delete params[key];
      });
      return params;
    }
  }, {
    key: "getCurrentFilters",
    value: function getCurrentFilters() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;

      if (!this.filterSet) {
        return {};
      }
      return _filters2.default.Set.getCurrentQuery(this.filterSet.props.children, context);
    }
  }, {
    key: "getCurrentOrdering",
    value: function getCurrentOrdering() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
      var query = context.location.query;

      return query.ordering || null;
    }
  }, {
    key: "getCurrentPage",
    value: function getCurrentPage() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
      var query = context.location.query;

      return parseInt(query.page, 10) || 1;
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this3 = this;

      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
      var _props = this.props,
          apiHandler = _props.apiHandler,
          captureException = _props.captureException,
          dataHandler = _props.dataHandler,
          errorHandler = _props.errorHandler,
          itemHandler = _props.itemHandler,
          url = _props.url;


      apiHandler().get(url, {
        params: this.getAPIParams(context)
      }).then(function (response) {
        if (!_this3._isMounted) {
          return;
        }
        _this3.setState(function (_ref3) {
          var data = _ref3.data;

          var responseData = response.data;

          if (dataHandler) {
            return dataHandler(data, responseData);
          }

          var count = responseData.count,
              results = responseData.results;

          return {
            data: data.set("count", count).set("loading", false).set("results", I.List((results || []).map(itemHandler))),
            dataError: null
          };
        });
      }).catch(function (err) {
        if (!_this3._isMounted) {
          return;
        }
        if (err.response) {
          _this3.setState(function (_ref4) {
            var data = _ref4.data;
            return {
              data: data.set("loading", false),
              dataError: errorHandler(err.response.data)
            };
          });
        } else if (captureException) {
          captureException(err);
        }
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _props2 = this.props,
          header = _props2.header,
          headerIcon = _props2.headerIcon,
          headerRenderer = _props2.headerRenderer;


      if (headerRenderer) {
        return headerRenderer(this.state);
      } else if (header || headerIcon) {
        return _react2.default.createElement(
          _SectionHeader2.default,
          { icon: headerIcon },
          header
        );
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          className = _props3.className,
          customRowRender = _props3.customRowRender,
          footerRenderer = _props3.footerRenderer,
          highlightMatch = _props3.highlightMatch,
          label = _props3.label,
          perPage = _props3.perPage;
      var _state = this.state,
          data = _state.data,
          dataError = _state.dataError;


      if (dataError) {
        return _react2.default.createElement(_ServerError2.default, { data: dataError });
      }

      var count = data.get("count");
      var loading = data.get("loading");
      var results = data.get("results");

      var columns = children.length;

      if (results === undefined) {
        return _react2.default.createElement(
          "div",
          { className: (0, _classnames2.default)("Table", className) },
          this.renderHeader(),
          _react2.default.createElement(
            "span",
            { className: "text-muted" },
            _react2.default.createElement(_LoadingIcon2.default, null)
          )
        );
      }

      var currentOrdering = this.getCurrentOrdering();
      var currentPage = this.getCurrentPage();

      var toolbar = _react2.default.createElement(
        "div",
        { className: "erg-table-toolbar clearfix" },
        Boolean(count) && _react2.default.createElement(_Toolbar2.default, {
          count: count,
          currentPage: currentPage,
          label: label,
          perPage: perPage }),
        this.filterSet
      );

      var content = [];
      var pagination = void 0;

      if (results.isEmpty()) {
        content = [_react2.default.createElement(
          "tr",
          { key: "empty" },
          _react2.default.createElement(
            "td",
            { className: "text-muted", colSpan: columns },
            "No ",
            label,
            " found."
          )
        )];
      } else {
        results.valueSeq().forEach(function (item, key) {
          var highlight = highlightMatch && highlightMatch(item, key);
          var defaultRender = _react2.default.createElement(
            _Row2.default,
            {
              data: item,
              highlight: highlight,
              key: item.slug ? "item-" + item.slug : key },
            children
          );
          if (customRowRender) {
            var customResult = customRowRender(item, results.get(key + 1), results, defaultRender);
            if (Array.isArray(customResult)) {
              content = content.concat(customResult);
            } else {
              content.push(customResult);
            }
          } else {
            content.push(defaultRender);
          }
        });
        pagination = Boolean(count) && _react2.default.createElement(_Pagination2.default, {
          count: count,
          currentPage: currentPage,
          perPage: perPage });
      }

      return _react2.default.createElement(
        "section",
        { className: (0, _classnames2.default)("Table", className) },
        this.renderHeader(),
        toolbar,
        _react2.default.createElement(_ProgressBar2.default, { show: loading }),
        _react2.default.createElement(
          "table",
          { className: "table" },
          _react2.default.createElement(
            "thead",
            null,
            _react2.default.createElement(
              "tr",
              null,
              children.map(function (item, key) {
                return (0, _react.cloneElement)(item, { currentOrdering: currentOrdering, key: key });
              })
            )
          ),
          _react2.default.createElement(
            "tbody",
            null,
            content
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "Table-Footer" },
          pagination,
          footerRenderer && footerRenderer(this.state)
        )
      );
    }
  }, {
    key: "filterSet",
    get: function get() {
      var filterSet = this.props.filterSet;

      if (!filterSet) {
        return null;
      }

      var newProps = Object.assign({
        queryToReset: {
          page: 1
        }
      }, filterSet.props);

      return (0, _react.cloneElement)(filterSet, newProps);
    }
  }]);

  return Table;
}(_react.Component), _class.displayName = "Table", _class.Cell = _Cell2.default, _class.Column = _Column2.default, _class.Pagination = _Pagination2.default, _class.ProgressBar = _ProgressBar2.default, _class.Row = _Row2.default, _class.Toolbar = _Toolbar2.default, _class.contextTypes = {
  location: _react.PropTypes.object.isRequired
}, _class.defaultProps = {
  loading: false
}, _class.propTypes = {
  apiHandler: _react.PropTypes.func.isRequired,
  captureException: _react.PropTypes.func,
  children: _react.PropTypes.array.isRequired,
  className: _react.PropTypes.string,
  customRowRender: _react.PropTypes.func,
  dataHandler: handlersValidator,
  errorHandler: _react.PropTypes.func,
  filterSet: _react.PropTypes.node,
  footerRenderer: _react.PropTypes.func,
  header: _react.PropTypes.node,
  headerIcon: _react.PropTypes.string,
  headerRenderer: _react.PropTypes.func,
  highlightMatch: _react.PropTypes.func,
  itemHandler: handlersValidator,
  label: _react.PropTypes.string.isRequired,
  perPage: _react.PropTypes.number.isRequired,
  url: _react.PropTypes.string
}, _temp2);
exports.default = Table;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/table/index.js
 ** module id = 801
 ** module chunks = 0
 **/